import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotes: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"notes"} maskId="square-filled-radius-0-stroke-1-IconNotes"><path fillRule="evenodd" clipRule="evenodd" d="M3.5625 2.5H20.5V21.5H3.5625V16H2.5V15H3.5625V12.5H2.5V11.5H3.5625V9H2.5V8H3.5625V2.5ZM9 8H15V9H9V8ZM9 11.5H13V12.5H9V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNotes;
